import { Container } from '@Calix-Commerce/design-system/layout';
import { getI18NText } from 'I18N/I18N';
import { AdditionalShippingInstruction } from './AdditionalShippingInstruction';
import { AdditionalShippingInfoWarning } from './styledComponents';

export const ShippingInstructions = ({
  packagingInstruction,
  onPackagingInstructionChange,
  shippingInstruction,
  onShippingInstructionChange,
}) => {
  return (
    <>
      <Container>
        <AdditionalShippingInfoWarning>
          {getI18NText('SPLIT_SHIPMENT_WARNING_1')}
          <br></br>
          <b>{getI18NText('SPLIT_SHIPMENT_WARNING_2')}</b>&nbsp;
          <a href="mailto:calixcustomeroperations@calix.com" target="_blank">
            calixcustomeroperations@calix.com
          </a>
          &nbsp;<b>{getI18NText('SPLIT_SHIPMENT_WARNING_3')}</b>
        </AdditionalShippingInfoWarning>
        <AdditionalShippingInstruction
          id="packagin-instructions"
          label={getI18NText('PACKAGING_INSTRUCTIONS')}
          characterLimit={1000}
          onInstructionChange={onPackagingInstructionChange}
          instruction={packagingInstruction}
          instructionInfo={getI18NText('PACKAGING_INSTRUCTIONS_INFO')}
        />
        <AdditionalShippingInstruction
          id={'shipping-instructions'}
          label={getI18NText('SHIPPING_INSTRUCTIONS')}
          characterLimit={1000}
          onInstructionChange={onShippingInstructionChange}
          instruction={shippingInstruction}
          instructionInfo={getI18NText('SHIPPING_INSTRUCTIONS_INFO')}
        />
      </Container>
    </>
  );
};
